export const assetGroupBoxes = {
  namespaced: true,
  //persistent: ["assetGroupCategory", "assetGroup", "datasource", "data"],

  state: {
    assetGroupCategory: undefined,
    assetGroup: undefined,
  },
  getters: {
    assetGroupCategory: (state) => state.assetGroupCategory,
    assetGroup: (state) => state.assetGroup,
  },
  mutations: {
    clear: (state, va) => {
      state.assetGroupCategory = undefined;
      state.assetGroup = undefined;
    },
    assetGroupCategory: (state, value) => {
      if (state.assetGroupCategory == value) {
        return;
      }
      state.assetGroupCategory = value;
      state.assetGroup = undefined;
    },
    assetGroup: (state, value) => {
      if (state.assetGroup == value) {
        return;
      }
      state.assetGroup = value;
    },
  },
  actions: {
    async selectAssetGroupCategory({ getters, rootGetters, commit, dispatch }, item) {
      if (getters.assetGroupCategory?._id == item._id) {
        commit("assetGroupCategory", undefined);
        commit("organizationAssetGroupCategory/selectedEntity", undefined, { root: true });
      } else {
        commit("assetGroupCategory", item);
        commit("organizationAssetGroupCategory/selectedEntity", item, { root: true });
      }
    },
    async selectAssetGroup({ getters, rootGetters, commit, dispatch }, item) {
      if (getters.assetGroup?._id == item._id) {
        commit("assetGroup", undefined);
        commit("organizationAssetGroup/selectedEntity", undefined, { root: true });
      } else {
        commit("assetGroup", item);
        commit("organizationAssetGroup/selectedEntity", item, { root: true });
      }
    },
  },
};
